import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Heart, HandHeart, ArrowUp } from "lucide-react";

export const MobileStickyCTA = () => {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (pathname === "/donate" || pathname === "/volunteer") return null;
  return (
    <div className={`lg:hidden fixed bottom-0 inset-x-0 z-40 transition-transform ${show ? "translate-y-0" : "translate-y-full"}`}>
      <div className="m-3 grid grid-cols-2 gap-2 rounded-2xl glass caf-shadow p-2">
        <Link to="/volunteer" data-testid="mobile-sticky-volunteer-button" className="h-11 flex items-center justify-center rounded-full border-2 border-foreground text-foreground font-semibold text-sm">
          <HandHeart className="h-4 w-4 mr-1.5" /> Volunteer
        </Link>
        <Link to="/donate" data-testid="mobile-sticky-donate-button" className="h-11 flex items-center justify-center rounded-full bg-[hsl(var(--orange))] hover:bg-[hsl(var(--orange-2))] text-black font-semibold text-sm">
          <Heart className="h-4 w-4 mr-1.5" /> Donate
        </Link>
      </div>
    </div>
  );
};

export const BackToTop = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      aria-label="Back to top"
      data-testid="back-to-top-button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`hidden lg:flex fixed bottom-6 right-6 z-40 h-11 w-11 items-center justify-center rounded-full bg-foreground text-background caf-shadow hover:opacity-90 focus-ring transition-opacity ${show ? "opacity-100" : "opacity-0 pointer-events-none"}`}
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
};
